
    export default {
        name: 'FilterDisplaySorting',
        methods: {
            handleClickSorting() {
                // const type = this.mode.split(' ');
                this.$store.commit('modal/setDisplayMobileFilter', {isOpen: true, mode: 'sorting'})
            }
        }
    }
